import type { Spec } from "@json-render/react";

import {
  buildMovesSignalCardSpec,
  type BuildMovesSignalCardSpecInput,
  type BuildMovesSignalCardSpecResult,
} from "@components/invest-moves/InvestNextMoves/buildMovesSignalCardSpec";
import { parseDynamicUiBody } from "@utils/parseDynamicUiBody";

export type ResolveSignalCardDynamicUiInput = BuildMovesSignalCardSpecInput;

export type ResolvedSignalCardDynamicUi = BuildMovesSignalCardSpecResult;

/**
 * 解析 `<dynamic_ui>` 并在 NotificationCardContainer 上注入 Asset*Card viz。
 * Tracker / Notification / Invest Moves 共用。
 */
const resolveSignalCardDynamicUi = (
  body: string,
  input: ResolveSignalCardDynamicUiInput = {},
): ResolvedSignalCardDynamicUi | null => {
  const enriched = buildMovesSignalCardSpec(body, input);
  if (enriched) {
    return enriched;
  }

  const spec = parseDynamicUiBody(body);
  if (!spec) {
    return null;
  }

  return {
    spec,
    renderContext: {
      notificationId: input.recordId,
      collapsed: false,
      isRead: input.readAt != null && input.readAt > 0,
      title: input.title,
      generatedAtMs: input.created,
      ...(input.sceneContext ? { sceneContext: input.sceneContext } : {}),
    },
  };
};

export const resolveSignalCardDynamicUiSpec = (
  body: string,
  input: ResolveSignalCardDynamicUiInput = {},
): Spec | null => resolveSignalCardDynamicUi(body, input)?.spec ?? null;
